// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Flag } from '../../../flag';
import { SVGWrapper } from '../../../svg-wrapper/svg-wrapper';
import { CheckIconSvg } from '../../../../assets/icons/check';
import { OptionCardContainer } from './style';
/**
 * Opção de escolha usada nos drawers de tenant e de idioma.
 *
 * O cartão inteiro é a área clicável — o `input` fica escondido, mas continua
 * no DOM para leitores de tela e navegação por teclado.
 */
export const OptionCard = ({ name, value, country, title, description, checked, onChange, }) => {
    const id = `${name}-${value}`;
    return (React.createElement(OptionCardContainer, { className: `option-card ${checked ? 'checked' : ''}` },
        React.createElement("label", { htmlFor: id },
            React.createElement("input", { type: "radio", name: name, id: id, value: value, checked: checked, onChange: (event) => onChange(event.target.value) }),
            React.createElement(Flag, { country: country }),
            React.createElement("span", { className: "option-card_text" },
                React.createElement("span", { className: "option-card_title" }, title),
                !!description && (React.createElement("span", { className: "option-card_description" }, description))),
            checked && (React.createElement("span", { className: "option-card_check" },
                React.createElement(SVGWrapper, { svg: CheckIconSvg }))))));
};
//# sourceMappingURL=index.js.map